const Badge = ({ icon, title }: { icon: React.ReactNode, title: string }) => {
  return (
    <div className="flex flex-row items-center gap-2">
      <div className="primary-color">
        {icon}
      </div>
      <span className="text-sm lg:text-base font-semibold text-slate-700">{title}</span>
    </div>
  )
}

export default Badge;